// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"579":"fde18fde","2188":"850fe3e2","2769":"fde18fde","5930":"c815a5d5","7573":"815efc18"}[chunkId] + ".chunk.css";
};